export default __webpack_public_path__ + "static/media/02.4739be40.png";